// jsonStatus values enum
export enum DepositorDoorStatus {
  opened = 'opened',
  closed = 'closed',
  locked = 'locked',
}
